
import Vue from 'vue';
import Avatar from './Avatar.vue';

export default Vue.extend({
    name: 'Profile',

    components: {
        Avatar
    },

    props: {
        userId: {
            type: String,
            default: ''
        },
        userName: {
            type: String,
            default: ''
        },
        questionId: {
            type: String,
            default: ''
        },
        profilePicture: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        noSubtitle: {
            type: Boolean,
            default: false
        },
        showUserInitials: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        onProfileClick() {
            this.$emit('click');
        }
    }
});
